import React from "react";
import Surveys from "./surveys";
import CustomTabs from "../../components/customTabs/customTabs";
import { SurveyTeam } from "./surveyTeams";

const MainSurvey = () => {
  const data = [
    {
      title: "All Surveys",
      render: <Surveys src={"out"} />,
    },
    {
      title: "Teams",
      render: <SurveyTeam />,
    },

  ];
  return (
    <>
      <CustomTabs data={data} />
    </>
  );
};

export default MainSurvey;
